import React from 'react';
import { Shield, Lock, FileCheck, Eye } from 'lucide-react';

export const Security = () => {
  const securityFeatures = [
    {
      icon: Shield,
      title: 'DDoS Protection',
      description: 'Enterprise-grade DDoS mitigation protecting your infrastructure 24/7'
    },
    {
      icon: Lock,
      title: 'End-to-End Encryption',
      description: 'AES-256 encryption for data at rest and TLS 1.3 for data in transit'
    },
    {
      icon: FileCheck,
      title: 'Compliance Ready',
      description: 'ISO 27001, SOC 2, and GDPR compliant infrastructure'
    },
    {
      icon: Eye,
      title: 'Security Monitoring',
      description: 'Real-time threat detection and automated incident response'
    }
  ];

  return (
    <section id="security" className="py-16 md:py-32 bg-[#0A0E14] relative overflow-hidden">
      <div className="absolute inset-0 pro-grid opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-block mb-3 md:mb-4">
            <span className="text-green-400 text-[10px] md:text-xs font-semibold uppercase tracking-wider">
              Security & Compliance
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4">
            Enterprise-Grade <span className="text-green-400">Security</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            Your data is protected with bank-level security standards
          </p>
        </div>

        {/* Security Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
          {securityFeatures.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="corner-accent"
                style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${index * 100}ms`, opacity: 0 }}
              >
                <div className="glass-card rounded-xl p-6 md:p-8 h-full hover:border-green-500/20 transition-all duration-300">
                  <div className="w-10 h-10 md:w-12 md:h-12 mb-4 md:mb-5 bg-green-500/10 rounded-lg flex items-center justify-center">
                    <Icon className="text-green-400" size={20} />
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-white mb-2 md:mb-3">{feature.title}</h3>
                  <p className="text-gray-400 text-xs md:text-sm leading-relaxed">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Compliance Badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {['ISO 27001', 'SOC 2 Type II', 'GDPR', 'PCI DSS'].map((badge, index) => (
            <div 
              key={index}
              className="glass-card px-4 md:px-8 py-2 md:py-4 rounded-lg border-green-500/10"
              style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${0.5 + index * 0.1}s`, opacity: 0 }}
            >
              <span className="text-gray-300 font-semibold text-xs md:text-sm">{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};